export default {
  required: 'This field is required.',
  is: 'This field must be identical.',
  email: 'Your email address must be valid.',
  rte_max_length: 'You entered too many words. Please shorten the input.',
};
